import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {

   constructor() { }

  ngOnInit(): void {
  }
  products = [
    { name: 'Makhana', image: 'makhana_ne.jpg', description: 'Premium healthy fox nuts from India.' },
    { name: 'Tea', image: 'tea.jpg', description: 'Fresh and aromatic Indian tea leaves.' },
    { name: 'Coffee', image: 'coffee.webp', description: 'Rich taste premium coffee beans.' },
    { name: 'Turmeric', image: 'haldi.webp', description: 'Pure natural turmeric powder.' },
    { name: 'Cumin Seeds', image: 'cumin.png', description: 'Best quality Indian cumin seeds.' },
    // { name: 'Black Pepper', image: 'pepper.jpg', description: 'Strong aroma premium pepper.' },
    { name: 'Ginger', image: 'ginger.webp', description: 'Pure natural ginger powder' },
    { name: 'Ashwagandha', image: 'ashwagandha.jpg', description: 'Natural wellness herb product.' },
    { name: 'Moringa Powder', image: 'moringa.webp', description: 'Healthy superfood powder.' },
    { name: 'Red Chilli', image: 'redchilli.webp', description: 'Pure red chilli turmeric powder.' },
    { name: 'Cinnamon', image: 'cinnamon.jpg', description: 'Fresh aromatic cinnamon sticks.' }
  ];
}
